import { TravelPolicyModel } from './TravelPolicyModel';
import { TravelstatusMdl } from './TravelBindMdl';
export class TravelProposalModel {
    public ProposalNo: string;
    public Name: string;
    public TotalPremium: number;
    public Status: string;
    public proposalFileName: string;
    public PolicyCardFileName: string;
    public PaymentStatus: number;
    public Mobile: string;
    public Email: string;
    public isUnderWriter: string;
    public EProposalNo: string;
    public PaySig: string;
    public EPayInfo: string;
    public ProductCode: string;
    public ProductDesc: string;
    public ProposalType: string;

    public ProposalFromDate: string;
    public ProposalToDate: string;

    public myProObj: TravelProposalInfoModel = new TravelProposalInfoModel();
    public transObj: TravelTransInfoModel = new TravelTransInfoModel();
    public newPolicyObj: TravelPolicyModel = new TravelPolicyModel();

    public isProposalEdit: boolean;
    public PaymentExpiryStatus: string;
    public SadadBillNo: string;
    public SadadBillExp: string;
}

export class TravelProposalInfoModel {

    public EncProposalNo: string;
}

export class TravelTransInfoModel {
    public RegNo: string;
    public ProposalNo: string;

    public InsuredName: string;
    public Premium: string;

    public ProductCode: string;

    public Email: string;
    public Mobile: string;

    public merchantRefNum: string;
    public OLPID: string;

    public TransDate: string;
    public st: TravelstatusMdl = new TravelstatusMdl();

    public isUnderwriter: boolean;
    public uploadNo: string;

    public PMethod: string;
    public EProposalNo: string;

    public EPayInfo: string;
    public PaySig: string;

    public IBAN: string;
    public BankCode: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelProposalModel.ts